module.exports = class PresetsChooser {
    constructor(formDomNode) {
        this.radioGroup = formDomNode;
        this.input = this.radioGroup.querySelector('[data-js-no-preset-input]');
        this.radio = this.radioGroup.querySelector('[data-js-no-preset-radio]');
        this.currentValue = '';

        this.onInput = this.onInput.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onDirectInput = this.onDirectInput.bind(this);
    }

    init() {
        this.addEventListeners();
        this.initState();
    }

    addEventListeners() {
        this.radioGroup.addEventListener('change', this.onChange);

        this.input.addEventListener('focus', this.onDirectInput);
        this.input.addEventListener('input', this.onInput);
    }

    initState() {
        if (this.radio.checked) {
            this.activateInput();
        } else {
            this.deactivateInput();
        }
    }

    onInput(event) {
        this.filterInput(event.target.value);
        this.input.value = this.currentValue;
    }

    onChange(event) {
        if (event.target.tagName !== 'INPUT' && event.target.getAttribute('type') !== 'radio') {
            return;
        }

        if (this.input.validity.valid) {
            this.input.classList.remove('is-invalid');
        }

        if (this.radio.checked) {
            this.activateInput();
        } else {
            this.input.value = event.target.getAttribute('value');
            this.deactivateInput();
        }
    }

    onDirectInput() {
        this.radio.checked = true;
        this.input.select();
        this.activateInput();
    }

    activateInput() {
        this.input.setAttribute('required', '');
        this.input.setAttribute('tabindex', '0');
    }

    deactivateInput() {
        this.input.removeAttribute('required');
        this.input.setAttribute('tabindex', '-1');
    }

    filterInput(value) {
        if (value === '' || value === '-') {
            return this.currentValue = 0;
        }
        const parsedInput = parseInt(value, 10);

        let result = parsedInput;

        if (parsedInput < 0) {
            result = 1;
        }

        this.currentValue = result;
    }
};
